import { waitFor } from 'util/misc';
import config from 'config';

const getStoreFrom = (storage) => ({
  set: (name, value) => storage.setItem(name, JSON.stringify(value)),
  get: (name) => {
    const value = storage.getItem(name);
    try {
      return value && JSON.parse(value);
    } catch (e) {
      return value;
    }
  },
  remove: (name) => storage.removeItem(name),
  clear: () => storage.clear(),
});

export const persistentStore = getStoreFrom(localStorage);
export const sessionStore = getStoreFrom(sessionStorage);

const memStorage = {};
export const memStore = {
  set: (name, value) => (memStorage[name] = value),
  get: (name) => memStorage[name],
  getOrWaitFor: (name, options) => waitFor(() => memStorage[name], options),
  remove: (name) => delete memStorage[name],
  clear: () => Object.keys(memStorage).forEach((key) => delete memStorage[key]),
  storage: config.IS_DEV && memStorage,
};

if (config.IS_DEV && window) {
  window.memStore = memStore;
}
